const hostname = window.location.hostname;
const parts = hostname.split('.');
const uatEnv = parts[0] && parts[0].includes('uat');
const domainName = `${parts[1]}.${parts[2]}` ;
export const isProduction = hostname !== 'localhost';
const subSso = uatEnv ? 'uat-sso' : 'sso';
const ssoBaseUrl = (isProduction) ? `https://${subSso}.${domainName}` : 'http://localhost:8080/';
const sub = uatEnv ? 'uat-api' : 'api';
const grpcSub = uatEnv ? 'uat-grpc' : 'grpc';
export const apiUrl = (isProduction) ? `https://${sub}.${domainName}/api` : 'http://localhost:9000/api';
export const grpcApiUrl = (isProduction) ? `https://${grpcSub}.${domainName}` : 'http://localhost:8082';
export const logoutUrl = `${ssoBaseUrl}/realms/hello/protocol/openid-connect/logout`;

export function getKeycloakConfig() {
  return {
    url: ssoBaseUrl,
    realm: 'hello',
    clientId: 'portal'
  };
}
